<div class="keyboard-shortcuts-menu"
     *ngIf="isShortcutsMenuOpened"
     (keydown)="handleKeyDown($event)"
     tabindex="0"
     #keyboardPanel
     [setFocusOn]="focusEventName"
     (click)="closeKeyboardShortcutsMenu()">
  <div class="modal-content" data-automation-id="keyboard-shortcuts-content" (click)="$event.stopPropagation(); $event.preventDefault()">
    <div class="modal-header" data-automation-id="keyboard-shortcuts-header">
      <span class="keyboard-shortcut-title">{{ "bcKeyboardShortcuts.settingsTitle" | translate }}</span>
      <svg-icon icon="x" (click)="closeKeyboardShortcutsMenu()"></svg-icon>
    </div>
    <div class="modal-body">
      <div class="confirm-item" *ngFor="let workItemType of endingConfirmationList">
        <span>{{ getConfirmTitle(workItemType) | translate }}</span>
        <ui-switch size="small"
                   (click)="toggleEndingConfirmation(workItemType)"
                   [checked]="!isEndingConfirmDisabled(workItemType)">
        </ui-switch>
      </div>
    </div>
    <div class="modal-header">
      <span class="keyboard-shortcut-title">{{ "bcKeyboardShortcuts.keyboardShortcutsTitle" | translate }}</span>
    </div>
    <ng-container *ngFor="let shortcutTypes of keyboardShortcutList">
      <div class="modal-body" *ngIf="hasVisibleShortcuts(shortcutTypes?.shortcuts)">
        <div class="keyboard-shortcut-group-title">{{ shortcutTypes.title | translate }}</div>
        <div class="keyboard-shortcut-list">
          <ng-container *ngFor="let shortcut of shortcutTypes?.shortcuts">
            <div class="keyboard-shortcut-item" *ngIf="isShortcutVisible(shortcut)">
              <span class="keyboard-shortcut-item-keys">
                <div class="button-box">{{ shortcut.keyboardCombination[0] }}</div>
                  <div *ngIf="shortcut.keyboardCombination[1]"> +
                    <div class="button-box">{{ shortcut.keyboardCombination[1] }}</div>
                  </div>
                  <div *ngIf="shortcut.keyboardCombination[2]"> +
                    <div class="button-box">{{ shortcut.keyboardCombination[2] }}</div>
                  </div>
              </span>
              <span class="keyboard-shortcut-item-description">{{ shortcut.description | translate }}</span>
              <ui-switch size="small"
                        *ngIf="shortcut.configurable"
                        (click)="toggleShortcutAvailability(shortcut.keyboardCombination)"
                        [checked]="!isShortcutDisabled(shortcut.keyboardCombination)"
                        [attr.data-automation-id]="getKeyboardShortcut(shortcut.keyboardCombination)">
              </ui-switch>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
